
import { Vue, Component, Prop } from 'vue-property-decorator'
import { bannerDto } from '@/api/homes'
import { ImagePreview } from 'vant'

@Component
export default class BannerSwiper extends Vue {
  @Prop() banners: bannerDto[]

  preview (index: number) {
    let previewArr=[]
    this.banners.map(item=>{
        previewArr.push(this.$downloadUrl(item.picture))
    })
    ImagePreview({images: previewArr,startPosition:index})
  }
}
